module.exports = __webpack_public_path__ + "img/appIcon-mono--Subscriptions.f9ae089b.svg";